import React from 'react'

interface BrandIconProps {
  size?: number
}

// @material-ui/icons has no Google brand glyph and its Facebook glyph doesn't match Meta's current
// mark, so both providers get a small hand-written SVG here for a consistent look.
export const MetaIcon = ({ size = 20 }: BrandIconProps) => (
  <svg width={size} height={size} viewBox="0 0 40 40" aria-label="Meta">
    <circle cx="20" cy="20" r="20" fill="#0866FF" />
    <path
      fill="#fff"
      d="M26.7 25.3l.9-5.7h-5.5v-3.7c0-1.6.6-2.8 3-2.8h2.7V8c-1.4-.2-3-.4-4.4-.4-4.6 0-7.8 2.8-7.8 7.8v3.5H11v5.7h4.6V38c1 .2 2 .2 3 .2s2-.1 3-.2V25.3h5.1Z"
    />
  </svg>
)

export const GoogleIcon = ({ size = 20 }: BrandIconProps) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-label="Google">
    <path
      fill="#FFC107"
      d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5Z"
    />
    <path
      fill="#FF3D00"
      d="m6.3 14.7 6.6 4.8C14.7 15.9 18.9 13 24 13c3.1 0 5.8 1.1 8 3l5.7-5.7C34.6 6.1 29.6 4 24 4c-7.5 0-14 4.2-17.7 10.7Z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.5 0 10.4-1.9 14.1-5.1l-6.5-5.5A11.9 11.9 0 0 1 24 36c-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.4 39.6 16.1 44 24 44Z"
    />
    <path
      fill="#1976D2"
      d="M43.6 20.5H42V20H24v8h11.3a12 12 0 0 1-4.1 5.6l6.5 5.5C41.5 36 44 30.5 44 24c0-1.2-.1-2.4-.4-3.5Z"
    />
  </svg>
)
